// extracted by mini-css-extract-plugin
export default {"imageWrapper":"eH-z","twoColumnImage":"fH-z"};